import SelectedValue from "@components/request-access/SelectedValue";
import { Funnel, Search, X } from "@piiqtechnologies/svg-icons";
import { PeekInput, PeekListItemText, PeekMenuItem, PeekSelect, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { useDebounce, usePolicyContext } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
const SELECT_ALL_OPTION = "all";
const CLEAR_SELECTION_OPTION = "clear";
const MultipleCommunitySelector = ({ communities, selectedCommunities, onSelectionChange, placeholder, feature, isCombined, hideValues, style, showFilterIcon = true, size = "large", }) => {
    const intl = useIntl();
    const theme = useTheme();
    const [openSelectCommunities, setOpenSelectCommunities] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [auxCommunities, setAuxCommunities] = useState([]);
    useEffect(() => {
        if (debouncedSearchKey === "") {
            setAuxCommunities(communities);
        }
        else {
            setAuxCommunities(communities.filter((community) => community.name.toLowerCase().includes(debouncedSearchKey.toLowerCase())));
        }
    }, [communities, debouncedSearchKey]);
    const filteredCommunities = useMemo(() => {
        if (!communities)
            return [];
        if (!feature)
            return communities.map((community) => community._id);
        return communities === null || communities === void 0 ? void 0 : communities.map((community) => { var _a; return usePolicyContext(((_a = community === null || community === void 0 ? void 0 : community.features) === null || _a === void 0 ? void 0 : _a.includes(feature)) && feature) && (community === null || community === void 0 ? void 0 : community._id); }).filter(Boolean);
    }, [communities, feature]);
    const toggleSelectCommunities = () => {
        setOpenSelectCommunities(!openSelectCommunities);
    };
    const handleSelectCommunity = (event) => {
        if (event.target.value.includes(SELECT_ALL_OPTION)) {
            const communitiesSelected = event.target.value.includes(SELECT_ALL_OPTION)
                ? filteredCommunities
                : event.target.value;
            onSelectionChange(communitiesSelected);
        }
        else if (event.target.value.includes(CLEAR_SELECTION_OPTION)) {
            onSelectionChange([]);
        }
        else {
            onSelectionChange(event.target.value);
        }
    };
    const removeSelectedCommunity = (propertyId) => {
        onSelectionChange(selectedCommunities.filter((propId) => propId !== propertyId));
    };
    const SelectUnselectAllOption = useMemo(() => {
        const isAllSelected = (filteredCommunities === null || filteredCommunities === void 0 ? void 0 : filteredCommunities.length) === (selectedCommunities === null || selectedCommunities === void 0 ? void 0 : selectedCommunities.length);
        return (React.createElement(PeekMenuItem, { key: isAllSelected ? CLEAR_SELECTION_OPTION : SELECT_ALL_OPTION, value: isAllSelected ? CLEAR_SELECTION_OPTION : SELECT_ALL_OPTION, "aria-label": isAllSelected ? "Clear selection" : "Select All Communities", hoverBgColor: "info", selectedBgColor: "info" },
            React.createElement(PeekListItemText, null, !!isAllSelected ? intl.formatMessage(messages.clearSelection) : intl.formatMessage(messages.selectAll))));
    }, [communities, selectedCommunities]);
    //@ts-ignore
    return (React.createElement(PeekSelect, { key: "_id", value: selectedCommunities, onChange: handleSelectCommunity, inputProps: { "aria-label": "Your Communities" }, style: style !== null && style !== void 0 ? style : {
            width: "max-content",
            maxWidth: "445px",
        }, IconComponent: () => null, showBorder: true, displayEmpty: true, multiple: true, renderValue: (selected) => {
            return (React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 1.5 },
                showFilterIcon && React.createElement(Funnel, { fontSize: 18, color: theme.palette.grey[400] }),
                React.createElement(SelectedValue, { toggleSelectProperties: toggleSelectCommunities, removeSelected: removeSelectedCommunity, selected: selected, values: communities, placeholder: placeholder || intl.formatMessage(messages.selectPropertyPlaceholder), hideValues: hideValues })));
        }, open: openSelectCommunities, onClose: toggleSelectCommunities, MenuProps: {
            disablePortal: true,
        }, sx: {
            ".MuiSelect-select": {
                padding: "4px 15px !important",
            },
            minWidth: theme.spacing(25),
            minHeight: "fit-content",
            height: theme.spacing(size === "small" ? 3.8 : 4.2),
            backgroundColor: "common.white",
            borderTopRightRadius: isCombined === "left" ? 0 : "8px",
            borderBottomLeftRadius: isCombined === "right" ? 0 : "8px",
            borderTopLeftRadius: isCombined === "right" ? 0 : "8px",
            borderRight: isCombined === "left" ? "none" : `1px solid ${theme.palette.grey[200]}`,
            borderLeft: isCombined === "right" ? "none" : `1px solid ${theme.palette.grey[200]}`,
        } },
        SelectUnselectAllOption,
        React.createElement(PeekMenuItem, { key: "search", value: undefined, "aria-label": "Search", hoverBgColor: "info", selectedBgColor: "info", onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), sx: {
                pt: 0,
                backgroundColor: `${theme.palette.common.white} !important`,
                cursor: "default",
            } },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 1, width: "100%" },
                React.createElement(Search, { fontSize: 18, color: theme.palette.grey[400] }),
                React.createElement(PeekInput, { sx: {
                        width: "100%",
                        maxWidth: "445px",
                    }, field: {
                        name: "search",
                        value: searchKey,
                        onChange: (e) => {
                            setSearchKey(e.target.value);
                            e.stopPropagation();
                        },
                        onBlur: () => { },
                    }, form: {
                        values: undefined,
                        errors: undefined,
                        touched: undefined,
                    } }),
                searchKey !== "" && (React.createElement(PeekTypography, { onClick: () => setSearchKey(""), color: theme.palette.grey[400], sx: {
                        cursor: "pointer",
                        position: "absolute",
                        right: "25px",
                        top: "19px",
                    } },
                    React.createElement(X, null))))), auxCommunities === null || auxCommunities === void 0 ? void 0 :
        auxCommunities.map((community) => {
            var _a;
            return (React.createElement(PeekMenuItem, { key: community._id, value: community._id, "aria-label": community.name, disabled: !feature ? false : !((_a = community === null || community === void 0 ? void 0 : community.features) === null || _a === void 0 ? void 0 : _a.includes(feature)), hoverBgColor: "info", selectedBgColor: "info" },
                React.createElement(PeekListItemText, { primaryTypographyProps: {
                        fontWeight: selectedCommunities.includes(community._id) ? "fontWeightBold" : "fontWeightRegular",
                    } }, community.name)));
        })));
};
export default MultipleCommunitySelector;
